import { render, staticRenderFns } from "./decision1.vue?vue&type=template&id=0df6c272&scoped=true"
import script from "./decision1.vue?vue&type=script&lang=js"
export * from "./decision1.vue?vue&type=script&lang=js"
import style0 from "./decision1.vue?vue&type=style&index=0&id=0df6c272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6c272",
  null
  
)

export default component.exports